import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Row, Col } from 'react-bootstrap';

import { parseQs, stringifyQs } from 'helpers/http';

import DatePicker from 'components/forms/DatePicker';

import ListFilterBody from 'components/layout/list/ListFilterBody';

class ListFilterDateBetween extends React.Component {
  constructor(props) {
    super(props);
    let {
      dateFrom: stateDateFrom,
      dateTo: stateDateTo,
      fromMinDate: stateFromMinDate,
      fromMaxDate: stateFromMaxDate,
      toMinDate: stateToMinDate,
      toMaxDate: stateToMaxDate,
    } = props;

    stateFromMinDate =
      (stateFromMinDate && stateFromMinDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })) || undefined;
    stateFromMaxDate =
      (stateFromMaxDate && stateFromMaxDate.set({ hour: 23, minute: 59, second: 59, millisecond: 99 })) || undefined;
    stateToMinDate =
      (stateToMinDate && stateToMinDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })) || undefined;
    stateToMaxDate =
      (stateToMaxDate && stateToMaxDate.set({ hour: 23, minute: 59, second: 59, millisecond: 99 })) || undefined;

    if (stateDateFrom === undefined) {
      stateDateFrom = stateFromMinDate;
    }

    if (stateDateTo === undefined) {
      stateDateTo = stateToMaxDate;
    }

    this.state = { stateDateFrom, stateDateTo, stateFromMinDate, stateFromMaxDate, stateToMinDate, stateToMaxDate };
  }

  resetDates = e => {
    e.preventDefault();

    const { history, location } = this.props;
    const query = parseQs(location.search);

    history.push({
      pathname: location.pathname,
      search: stringifyQs({ ...query, dateFrom: undefined, dateTo: undefined }),
    });
  };

  updateSearchDate = (fieldName, searchDate) => {
    const { history, location } = this.props;

    const query = parseQs(location.search);

    history.push({
      pathname: location.pathname,
      search: stringifyQs({ ...query, [fieldName]: searchDate.format('YYYY-MM-DD') }),
    });

    if (fieldName === 'dateFrom') {
      this.setState({ stateDateFrom: searchDate });
    } else if (fieldName === 'dateTo') {
      this.setState({ stateDateTo: searchDate });
    }
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };

  render() {
    const { location, label, user, appIntl } = this.props;
    const {
      stateDateFrom,
      stateDateTo,
      stateFromMinDate,
      stateFromMaxDate,
      stateToMinDate,
      stateToMaxDate,
    } = this.state;

    const timezone = user && user.profile ? user.profile.timezone : 'UTC';
    const query = parseQs(location.search);
    const isActive = !!query.dateFrom || !!query.dateTo;

    return (
      <ListFilterBody
        title={label}
        isActive={isActive}
        paramNames={['dateFrom', 'dateTo']}
        body={
          <div className="form-group-attached padding-10">
            <Row>
              <Col xs={6}>
                <DatePicker
                  name="dateFrom"
                  value={stateDateFrom}
                  minDate={stateFromMinDate}
                  maxDate={stateFromMaxDate}
                  locale={appIntl.locale}
                  displayTz={timezone}
                  onChange={this.updateSearchDate}
                  label={null}
                />
              </Col>
              <Col xs={6}>
                <DatePicker
                  name="dateTo"
                  value={stateDateTo}
                  minDate={stateToMinDate}
                  maxDate={stateToMaxDate}
                  locale={appIntl.locale}
                  displayTz={timezone}
                  onChange={this.updateSearchDate}
                  label={null}
                />
              </Col>
            </Row>
          </div>
        }
      />
    );
  }
}
ListFilterDateBetween.defaultProps = {};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

export default withRouter(connect(mapStateToProps)(ListFilterDateBetween));
